import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AlertRuleListUI from '../../components/projectapp/alertRule/AlertRuleListUI'
import AlertRuleDeleteModalSF from '../../components/projectapp/alertRule/AlertRuleDeleteModalSF'

const AlertRuleListPageUI = ({context, messageList, alertRuleList, project, onRefreshClick,
    priorityList, dueInDaysList, duePastDaysList, repeatIntervalDaysList,
    // delete params
    deletingId, onDeleteClick, onCancelDeleteClick
  }) =>
  <PrivatePageSF context={context} className='pg_prj_alert' backLink='/projects'
    centered={(!alertRuleList) || (alertRuleList && alertRuleList.length === 0)}
    messageList={messageList} headerMessageKey='c_alert_rules'
    subHeaderText={`${project ? project.projectName : ''}`}
  >
    {
      !alertRuleList &&
      <SpinnerComponentUI />
    }
    {
      alertRuleList && alertRuleList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={project.permissionList.includes('prj_manage')}
        createLink={`/projects/${project.projectId}/alerts/create`}
        createLinkKey='c_set_alerts'
        createEnabledMessageKey='c_alert_rule_message'
        createDisabledMessageKey='c_no_alert_rules_msg'
      />
    }
    {
      alertRuleList && alertRuleList.length > 0 &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/projects'
          messageList={messageList} titleMessageKey='c_alert_rules'
          subTitleText={`${project ? project.projectName : ''}`}
        />
        <AlertRuleListUI
          context={context}
          messageList={messageList}
          alertRuleList={alertRuleList}
          project={project}
          onRefreshClick={onRefreshClick}
          priorityList={priorityList}
          dueInDaysList={dueInDaysList}
          duePastDaysList={duePastDaysList}
          repeatIntervalDaysList={repeatIntervalDaysList}
          onDeleteClick={onDeleteClick}
        />
        <div className='g_m_top_100'>
          <MessageUI messageList={messageList} messageKey='c_alert_rule_message' />
        </div>
      </React.Fragment>
    }

    <AlertRuleDeleteModalSF
      context={context}
      messageList={messageList}
      project={project}
      alertRuleId={deletingId}
      onCancel={onCancelDeleteClick}
      onRefresh={onRefreshClick}
    />
  </PrivatePageSF>

export default AlertRuleListPageUI
